import { render, staticRenderFns } from "./ai-image-upload.vue?vue&type=template&id=0236822a&lang=html"
import script from "./ai-image-upload.vue?vue&type=script&lang=js"
export * from "./ai-image-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports